import React from 'react';
import styles from './OwnerPicker.module.css';
import { ownerChoices, toggleOwner } from '../supportOwners';

type Props = {
  value: string[];
  onChange: (next: string[]) => void;
  /** The logged-in person's initials, offered too when they are not on the team list. */
  myInitials?: string;
  disabled?: boolean;
  label?: string;
};

/** Team, then each team member, as toggle chips. More than one person can be picked. */
export function OwnerPicker({ value, onChange, myInitials = '', disabled = false, label = 'Owners' }: Props) {
  return (
    <div className={styles.picker} role="group" aria-label={label}>
      {ownerChoices(myInitials).map((name) => {
        const on = value.includes(name);
        return (
          <button
            key={name}
            type="button"
            className={`${styles.chip} ${on ? styles.chipOn : ''} ${name === 'Team' ? styles.chipTeam : ''}`}
            aria-pressed={on}
            disabled={disabled}
            onClick={() => onChange(toggleOwner(value, name))}
          >
            {name}
          </button>
        );
      })}
    </div>
  );
}
